import alerts from './alerts';
import buttons from './buttons';
import dropdown from './dropdown';
import form from './form';
import grid from './grid';
import links from './links';
import modal from './modal';
import sort from './sort';
import toggle from './toggle';
import tabs from './tabs';
export default {
  alerts: alerts,
  buttons: buttons,
  dropdown: dropdown,
  form: form,
  grid: grid,
  links: links,
  modal: modal,
  sort: sort,
  toggle: toggle,
  tabs: tabs
};